export default __webpack_public_path__ + "static/media/Ganeshchaturti6.9e8ec286.JPG";